import { VuexModule, Module, Mutation, Action } from 'vuex-module-decorators'
import _ from 'lodash'
import { DataTablePagination, Hospital } from '@/types/_'
import Apis from '@/Apis/_'

type Mode = 'CREATE' | 'EDIT'

type SetSuporteModal = {
  name: string,
  value: boolean,
}

type SuporteModal = {
  procedimentoApenasHospitalDia: boolean,
}

interface ProcedimentoApenasHospitalDia {
  procedimentoId: string,
  codigo: string,
  procedimentoDescricao: string,
  convenioId: string,
  convenioDescricao: string,
  hospitalDia: boolean,
  status?: 'Ativo' | 'Removido',
}

interface Procedimento {
  id: string | null,
  codigo: string,
  descricao: string | null,
  porte: string | null,
  quantidadeAuxiliares: number,
  status: string,
  temLateralidade: boolean,
  tipo: string | null,
  hospitalId: string,
  hisId: string,
  tecnicasDoProcedimento: TecnicaDoProcedimento[],
}

interface TecnicaDoProcedimento {
  id: string,
  descricao: string,
}

interface Convenio {
  id: string,
  nome: string,
  particular: boolean,
  status: string,
  codigoOperadora: string,
  hospitalRealizaCotacao: boolean,
  convenioFazCodificacaoDeOpme: boolean,
  registroANS: string,
  tempoParaAutorizacao: null,
  hospitalId: string,
  hisId?: string,
  prazoEmDiasParaTriagem: number,
  prazoMaximoEmDiasParaAgendamento: number,
}

interface CargaProcedimentoHospitalDia {
  hospitalDia: boolean,
  conveniosId: string[],
  codigosTuss: string[] | string,
}

@Module({ namespaced: true, name: 'BackofficeProcedimentoHospitalDiaStore' })
export default class BackofficeProcedimentoHospitalDiaStore extends VuexModule {
  public hospitais: Hospital[] = []
  public hospitalId: string = ''

  public mode: Mode = 'CREATE'

  public modal: SuporteModal = {
    procedimentoApenasHospitalDia: false,
  }

  @Mutation
  setModal(modal: SetSuporteModal) {
    this.modal[modal.name] = modal.value
  }

  @Mutation
  setHospitais(value: Hospital[]) {
    this.hospitais = value
  }

  @Mutation
  setHospitalId(value: string) {
    this.hospitalId = value
  }

  @Mutation
  clearHospitais() {
    this.hospitais = []
  }

  @Mutation
  clearHospitalId() {
    this.hospitalId = ''
  }

  @Mutation
  setMode(param: any) {
    this.mode = param.mode
  }

  @Action
  forceCast<T>(obj: any) {
    return obj
  }

  @Action({ commit: 'setHospitais' })
  async getHospitais() {
    const request = await Apis.Agendamento.SuporteApi.getHospitaisByUserCurrent()
    if (request.success) {
      const data = request.data.map((c: any) => {
        const hospital = c
        hospital.id = _.toUpper(c.id)
        hospital.nome = _.toUpper(c.nome)
        return hospital
      })
      const hospitaisCast = await this.forceCast<Hospital[]>(data)
      return hospitaisCast
    }
    return []
  }

  /** Procedimentos Apenas Hospital Dia */
  private paginationProcedimentosApenasHospitalDiaDefault: DataTablePagination = {
    descending: false,
    page: 1,
    rowsPerPage: 5,
    sortBy: null,
    totalItems: 0,
    rowsPerPageItems: [5, 10, 25],
  }

  public paginationProcedimentosApenasHospitalDia: DataTablePagination = { ...this.paginationProcedimentosApenasHospitalDiaDefault }

  get procedimentosApenasHospitalDiaPaginationDefault() {
    return this.paginationProcedimentosApenasHospitalDia
  }

  private procedimentosApenasHospitalDiaDefault: ProcedimentoApenasHospitalDia[] = []
  public procedimentosApenasHospitalDia: ProcedimentoApenasHospitalDia[] = [...this.procedimentosApenasHospitalDiaDefault]
  private procedimentoApenasHospitalDiaDefault: ProcedimentoApenasHospitalDia = {
    procedimentoId: '',
    codigo: '',
    procedimentoDescricao: '',
    convenioId: '',
    convenioDescricao: '',
    hospitalDia: true,
  }

  public procedimentoApenasHospitalDia: ProcedimentoApenasHospitalDia = { ...this.procedimentoApenasHospitalDiaDefault }

  public searchProcedimentoApenasHospitalDia: string = ''

  @Mutation
  setSearchProcedimentoApenasHospitalDia(value: string) {
    this.searchProcedimentoApenasHospitalDia = value
  }

  @Mutation
  setPaginationProcedimentosApenasHospitalDia(val: DataTablePagination) {
    this.paginationProcedimentosApenasHospitalDia = val
  }

  @Mutation
  setProcedimentosApenasHospitalDia(value: ProcedimentoApenasHospitalDia[]) {
    this.procedimentosApenasHospitalDia = value
  }

  @Mutation
  clearProcedimentosApenasHospitalDia() {
    this.procedimentosApenasHospitalDia = [...this.procedimentosApenasHospitalDiaDefault]
  }

  @Mutation
  setProcedimentoApenasHospitalDia(value: ProcedimentoApenasHospitalDia) {
    this.procedimentoApenasHospitalDia = value
  }

  @Mutation
  clearProcedimentoApenasHospitalDia() {
    this.procedimentoApenasHospitalDia = { ...this.procedimentoApenasHospitalDiaDefault }
  }

  @Action
  async getProcedimentosApenasHospitalDiaPagedSearch(pagination: DataTablePagination) {
    try {
      const params: any = {
        hospitalId: this.hospitalId,
        pagina: pagination.page || this.paginationProcedimentosApenasHospitalDia.page,
        qtdPorPagina: pagination.rowsPerPage || this.paginationProcedimentosApenasHospitalDia.rowsPerPage,
        searchText: this.searchProcedimentoApenasHospitalDia,
      }

      const request = await Apis.Agendamento.SuporteApi.getAllProcedimentosApenasHospitalDiaByHospital(params)

      if (request.success) {
        this.context.commit('setProcedimentosApenasHospitalDia', request.data.procedimentosApenasHospitalDia as ProcedimentoApenasHospitalDia[] || [])
        this.context.commit('setPaginationProcedimentosApenasHospitalDia', {
          descending: false,
          page: pagination.page || this.paginationProcedimentosApenasHospitalDia.page,
          rowsPerPage: pagination.rowsPerPage || this.paginationProcedimentosApenasHospitalDia.rowsPerPage,
          sortBy: null,
          totalItems: request.data.total,
          rowsPerPageItems: this.paginationProcedimentosApenasHospitalDia.rowsPerPageItems,
        })
      }

      return request
    } catch (error) {
      this.context.commit('setProcedimentosApenasHospitalDia', [])
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }

  @Action
  async upsertProcedimentoApenasHospitalDia() {
    const params: ProcedimentoApenasHospitalDia = this.procedimentoApenasHospitalDia
    Object.entries(params).forEach(([key, value]) => {
      if (['', null, undefined].includes(value as any)) delete params[key]
    })

    const request = await Apis.Agendamento.SuporteApi.upsertProcedimentoApenasHospitalDia({ ...params, hospitalId: this.hospitalId })
    return request
  }

  /** Carga de procedimentos hospital dia */
  private cargaProcedimentoHospitalDiaDefault: CargaProcedimentoHospitalDia = {
    hospitalDia: true,
    conveniosId: [],
    codigosTuss: [],
  }

  public cargaProcedimentoHospitalDia: CargaProcedimentoHospitalDia = { ...this.cargaProcedimentoHospitalDiaDefault }

  @Mutation
  clearCargaProcedimentoHospitalDia() {
    this.cargaProcedimentoHospitalDia = { ...this.cargaProcedimentoHospitalDiaDefault }
  }

  @Action
  async cargaProcedimentosHospitalDia() {
    try {
      const params: CargaProcedimentoHospitalDia = { ...this.cargaProcedimentoHospitalDia }
      Object.entries(params).forEach(([key, value]) => {
        if (['', null, undefined].includes(value as any)) delete params[key]
        if (key === 'codigosTuss') params[key] = [...new Set((value as String).split('\n'))]
      })
      const request = await Apis.Agendamento.AgendamentoMedicoBackofficeApi.cargaProcedimentosHospitalDia({ ...params, hospitalId: this.hospitalId })
      return request
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }

  /** Convênios */
  public convenios: Convenio[] = []

  @Mutation
  setConvenios(value: Convenio[]) {
    this.convenios = value
  }

  @Mutation
  clearConvenios() {
    this.convenios = []
  }

  @Action
  async getConvenios() {
    try {
      const request = await Apis.Agendamento.SuporteApi.getAllConvenio(this.hospitalId)
      if (request.success) this.context.commit('setConvenios', request.data as Convenio[] || [])
      return request
    } catch (error) {
      this.context.commit('setConvenios', [])
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }
}
